import React from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {AudioProvider} from "./context/AudioProvider.js";
import {Analytics} from "./analytics/analytics.js";
import "./index.css";
import App from "./App.jsx";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AudioProvider>
                <BrowserRouter>
                    <Analytics/>
                    <App/>
                </BrowserRouter>
            </AudioProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
